namespace TabAurous.OMS {
    export interface UserForm {
        Type: UserEditor;
        Username: Serenity.StringEditor;
        DisplayName: Serenity.StringEditor;
        PartyId: Serenity.LookupEditor;
        Email: Serenity.EmailEditor;
        UserImage: Serenity.ImageUploadEditor;
        Source: Serenity.StringEditor;
        Password: Serenity.PasswordEditor;
        PasswordConfirm: Serenity.PasswordEditor;
        HasEdit: Serenity.BooleanEditor;
        EditPassword: Serenity.PasswordEditor;
        HasCatalogueAccess: Serenity.BooleanEditor;
        HasAuth: Serenity.BooleanEditor;
        AuthPassword: Serenity.PasswordEditor;
        ItemDiscount: Serenity.LookupEditor;
        Department: Serenity.LookupEditor;
        Branch: Serenity.LookupEditor;
    }

    export class UserForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.User';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UserForm.init)  {
                UserForm.init = true;

                var s = Serenity;
                var w0 = UserEditor;
                var w1 = s.StringEditor;
                var w2 = s.LookupEditor;
                var w3 = s.EmailEditor;
                var w4 = s.ImageUploadEditor;
                var w5 = s.PasswordEditor;
                var w6 = s.BooleanEditor;

                Q.initFormType(UserForm, [
                    'Type', w0,
                    'Username', w1,
                    'DisplayName', w1,
                    'PartyId', w2,
                    'Email', w3,
                    'UserImage', w4,
                    'Source', w1,
                    'Password', w5,
                    'PasswordConfirm', w5,
                    'HasEdit', w6,
                    'EditPassword', w5,
                    'HasCatalogueAccess', w6,
                    'HasAuth', w6,
                    'AuthPassword', w5,
                    'ItemDiscount', w2,
                    'Department', w2,
                    'Branch', w2
                ]);
            }
        }
    }
}
